// Pano360.js

import { useState, useEffect, useRef, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/CommonCtx';
import { getPosition } from '../contexts/CommonFunc';
import axios from 'axios';
import moment from 'moment';
import PulseLoader from 'react-spinners/PulseLoader';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
//import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
//import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
//import InputLabel from '@mui/material/InputLabel';
//import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
//import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import BottomNavigation from '@mui/material/BottomNavigation';

const Pano360 = (props) => {
    //console.log('pano_props', props);

    // loading
    const [ loading, setLoading ] = useState(false);

    // snackbar
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
   
    // selected tab
    const [ tab, setTab ] = useState('1');

    // common context
    const { user, ml, mode, camera, ppms, port } = useAuth();

    // pano's memo
    const memo1Ref = useRef(null);
    const memo1Value = useRef('');
    const [ memo1, setMemo1 ] = useState('');

    // background image
    const [ bgImgPano, setBgImgPano ] = useState('');

    // tabs element
    const elTabs = useRef(null);
    const imgPano = useRef(null);
    const fileInputPano = useRef(null);
    const fileGalleryPano = useRef(null);

    // all project list
    const projs = useRef([]);
    // selected project
    const [ proj, setProj ] = useState('');

    // selected panorama file
    const filePano = useRef('');
    // site picture upload button disabled
    const [ upPano, setUpPano ] = useState(true);

    const getProjects = useCallback(async() => {
        try {
            const url = `${ppms}:${port}/appms/projs`;
            const res = await axios.get(url, { withCredentials: true });
            //console.log('projs_res', res);
            projs.current = res.data;
            if (res.data.length > 0) {
                //setProj(res.data[0].proj_cd);
                //setProj(res.data[0].proj_id);
                return res.data[0].proj_id;
            } else {
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    const handleProjs = (e) => {
        //console.log('handle', e);
        setProj(e.target.value);

        // pano360
        if (filePano.current !== null) {
            setImgFile(filePano.current);
            setUpPano(false);
        } else {
            setUpPano(true);
        }
    };

    const setImgFile = (imgfile, nTab) => {
        let ifile = imgfile;
        let curr = tab;
        if (nTab !== undefined) curr = nTab;

        if (curr === '1') {
            if (!imgfile) ifile = filePano.current;
            //console.log('ifile1', ifile, imgfile);

            if (window.FileReader) {  // modern browser
                if (ifile) {
                    let reader = new FileReader();
                    reader.onload = function(ev) {
                        if (imgPano.current !== null) {
                            //imgPano.current.style.backgroundImage = `url(${ev.target.result})`;
                            setBgImgPano(ev.target.result);
                        }
                        //return `url(${ev.target.result})`;
                    }
                    reader.readAsDataURL(ifile);

                    // set file
                    //setFilePano(imgfile);
                } else {
                    //setFilePano('');
                    //return '';
                };
            } else {
                //setFilePano('');
                //return '';
            };
        };
    };

    const handleUpload = (e) => {
        //console.log('handle', e, proj);

        (async() => {
            setLoading(true);

            try {
                let pos = await getPosition();

                let formData = new FormData();
                let url = `${ppms}:${port}/appms/upload`;

                if (tab === '1') {
                    formData.append('file', filePano.current);
                    formData.append('fk_id', '');
                    formData.append('catg', 'PANO');
                    formData.append('type', 'PIC');
                    formData.append('location', '');
                    formData.append('user', '');
                    formData.append('time', moment().format('YYYY-MM-DD HH:mm:ss'));
                    //formData.append('time', moment().format('YYYYMMDDHHmmss'));
                    formData.append('lon', pos.coords.longitude);
                    formData.append('lat', pos.coords.latitude);
                    formData.append('code', '');
                    formData.append('status', '');
                    formData.append('proj_id', proj);
                    formData.append('memo', memo1);
                };
                //console.log(formData);

                const res = await axios.post(url, formData, { 'Content-Type': false, processData: false, enctype: 'multipart/form-data', withCredentials: true });
                //console.log('upload_res', res);
                setLoading(false);
                if (res.data.ok !== undefined && res.data.ok !== null && res.data.ok !== '') {
                    //console.log('upload_data', res.data.ok);
                    setSuccess(true);
                } else {
                    setFailed(true);
                };

                if (tab === '1') {
                    filePano.current = '';
                    fileInputPano.current.value = ''; //null;
                    setUpPano(true);
                    setBgImgPano('');
                };

            } catch(err) {
                console.log(err);
                setLoading(false);
                setFailed(true);
            }
        })();
    };

    const handleChangeTab = (e, newValue) => {
        setTab(newValue);

        if (elTabs.current !== null) {
            //elTabs.current.setAttribute('data-tab', newValue);
        };

        if (newValue === '1') {
            if (filePano.current !== null) {
                setImgFile(filePano.current, newValue);
            };
        };
    };

    const handleClickInput= (e) => {
        if (tab === '1') {
            //console.log('click', e, fileInputPano);
            e.target.value = ''; //null;

            // reload image file
            setImgFile(filePano.current);
        };
    };

    const handleChangeFile = (e) => {
        if (tab === '1') {
            //console.log('changeFile', e, fileInputPano);
            //e.preventDefault();

            if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
                setImgFile(e.target.files[0]);
                filePano.current = e.target.files[0];
                setUpPano(false);
            } else {
                setImgFile('');
                filePano.current = '';
                setUpPano(true);
            };

            //e.target.value = ''; // null;
        };
    };

    const handleChangeMemo = (e) => {
        //console.log('chage', e.target.value);
        if (tab === '1') {
            //setMemo1(e.target.value);
            //setMemo1(memo1Ref.current.focus());
            memo1Value.current = e.target.value;
        };
    };

    const handleBlurMemo = (e) => {
        //console.log('blur', e);
        if (tab === '1') {
            setMemo1(memo1Value.current);
        };
    };

    useEffect(() => {
        (async() => {
            let pid = await getProjects();
            setProj(pid);

            if (elTabs.current !== null) {
                //elTabs.current.setAttribute('data-tab', '1');
            };
        })();

        return () => {
            //console.log('unmount');
        };
    }, [ getProjects ]);

    useEffect(() => {
        //console.log('mode', mode, camera);

        let curr = elTabs.current.getAttribute('data-tab');

        if (mode === 'Pano360' && camera && camera.includes('action')) {
            if (curr === '1') {
                if (fileInputPano.current !== null) {
                    fileInputPano.current.click();
                }
            };
        } else if (mode === 'Pano360' && camera && camera.includes('gallery')) {
            if (curr === '1') {
                if (fileGalleryPano.current !== null) {
                    fileGalleryPano.current.click();
                }
            };
        };
    }, [ mode, camera ]);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    };

    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') return;
        setSuccess(false);
    };
    const handleCloseFailed = (event, reason) => {
        if (reason === 'clickaway') return;
        setFailed(false);
    };

    const ContainerPics = styled(Container)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        //alignItems: 'center',
        //justifyContent: 'center',
        background: '#f0f8ff',
        //background: theme.palette.grey[50],
    }));
    const BoxProj = styled(Box)(({theme}) => ({
        display: 'flex',
        //flexDirection: 'column',
        //flexGrow: 1,
        //flexDirection: {
        //    xs: 'column', // mobile
        //    sm: 'row', // tablet and up
        //},
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        //borderRadius: 10,
        //background: theme.palette.white,
        //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    const BoxImg = styled(Box)(({theme}) => ({
        //display: 'none',
        display: 'flex',
        width: '100%',
        height: '40vh',
        //backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
        //backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        //backgroundColor: '#ffffff', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        borderRadius: 5,
        borderColor : '#e0e0e0',
        borderWidth: '1px',
        borderStyle: 'solid',
    }));
    
    return (
        <ContainerPics maxWidth={false} disableGutters sx={{ m:0, p:0, width: '100%', flexGrow: 1 }}>
            <Toolbar />
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs variant="fullWidth" value={tab} data-tab={tab} ref={elTabs} onChange={handleChangeTab}>
                    <Tab label={ml.PANO_360} value="1" id="tab-360-1" aria-controls="tabpanel-360-1" sx={{ fontSize: 'min(16px, 3.6vmin)', fontWeight: 'bold' }} />
                </Tabs>
            </Box>
            <div role="tabpanel" hidden={tab !== '1'} id="tabpanel-360-1" aria-labelledby="tab-360-1" value="1">
                <Box sx={{ px: 2, py: 1 }}>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <Select id="sel-projs" value={proj} onChange={handleProjs} displayEmpty sx={{ color: '#1976d2' }}>
                                { projs.current.map((p, idx) => (
                                    <MenuItem key={p.proj_id} value={p.proj_id} dense sx={{ color: '#1976d2' }}>
                                        <Typography textAlign="center" variant="subtitle2">{p.proj_nm}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    <TextField ref={memo1Ref} variant="outlined" size="small" margin="dense" required fullWidth id="memo-tab1" label={ml.MEMO} name="Memo1" autoFocus
                        inputProps={{ maxLength: 250 }} defaultValue={memo1} onChange={handleChangeMemo} onBlur={handleBlurMemo}
                    />
                    <Button variant="contained" size="small" sx={{ my: 1 }} fullWidth onClick={handleUpload} disabled={upPano}>
                        <Typography textAlign="center" variant="subtitle2">{ml.UPLOAD}</Typography>
                    </Button>
                    <input type="file" name="filePano360" id="filePano360" accept="image/*" style={{ display: 'none' }} ref={fileInputPano} onClick={handleClickInput} onInput={handleChangeFile} />
                    <input type="file" name="fileGalleryPano360" id="fileGalleryPano360" accept="image/*" style={{ display: 'none' }} ref={fileGalleryPano} onClick={handleClickInput} onInput={handleChangeFile} />
                    <BoxImg ref={imgPano} sx={{ my: 1, backgroundImage: `url(${bgImgPano})` }} />
                </Box>
            </div>
            <Snackbar open={success} autoHideDuration={3000} onClose={handleCloseSuccess} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Successfully completed!
                </Alert>
            </Snackbar>
            <Snackbar open={failed} autoHideDuration={3000} onClose={handleCloseFailed} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseFailed} severity="error" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Failed!
                </Alert>
            </Snackbar>
            { loading && 
                <Modal open={loading}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <PulseLoader loading={loading} color="#36d7b7" height={30} />
                    </Box>
                </Modal>
            }
            <BottomNavigation value="" sx={{ display: 'block', minHeight: '56px', background: 'none' }} />
        </ContainerPics>
    );
};

export default Pano360;


